import { motion } from "framer-motion";
import { ShieldCheck, Clock, Banknote, Headphones } from "lucide-react";
import { WHY_SWITCH } from "../../data/servicesData";

const ICONS = [Banknote, ShieldCheck, Clock, Headphones];

export function TrustSection() {
  return (
    <section data-testid="trust-section" className="py-14 md:py-18 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <span className="text-red-600 font-bold text-xs tracking-[0.2em] uppercase font-body">
            The SYV Advantage
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-[44px] font-black mt-3 mb-3 tracking-tight">
            Why Choose Us?
          </h2>
          <p className="text-slate-500 text-base md:text-lg font-body">
            Experience the difference with our vendor solutions
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {WHY_SWITCH.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="bg-white rounded-3xl p-8 border border-slate-100 hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
              >
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5"
                  style={{ background: `${item.color}12` }}
                >
                  <Icon size={26} style={{ color: item.color }} />
                </div>
                <div className="text-3xl font-black mb-1 font-body" style={{ color: item.color }}>
                  {item.stat}
                </div>
                <div className="text-[11px] font-bold text-slate-400 uppercase tracking-[0.1em] mb-3 font-body">
                  {item.statLabel}
                </div>
                <h3 className="text-base font-extrabold text-slate-900 mb-2 font-body">{item.title}</h3>
                <p className="text-[13px] text-slate-500 leading-relaxed font-body">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
